module.exports = __webpack_public_path__ + "img/arrow_up.87413e63.svg";